import { render, staticRenderFns } from "./RevisionFinalCreate.vue?vue&type=template&id=b98d83b6"
import script from "./RevisionFinalCreate.vue?vue&type=script&lang=js"
export * from "./RevisionFinalCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports